import {
    useMemo,
} from 'react'
import clsx from 'clsx'

import injectClass from 'app/utils/injectClass'

import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import useEnumValues from 'app/hooks/useEnumValues'
import {
    ContainerStatus,
} from 'app/enums/label.enums'
import getFields from './ContainerNoteDetails.fields'
import getClassNames from './utils/getClassNameByNoteType'
import useStyles from './ContainerNoteDetails.styles'
import {
    ContainerNoteResponse,
} from './ContainerNodeDetails.types'

type Props = {
    name: string,
    data: ContainerNoteResponse,
}

export const ContainerNoteDetails = ({
    name,
    data,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    const modifiedNote = useMemo(() => {
        const modifiedNoteText = data.noteText?.includes('\n')
            ? data.noteText.split('\n').map((item) => {
                return (
                    <span key={`noteText-${item}`}>
                        {item}
                        <br />
                    </span>
                )
            }) : data.noteText

        return {
            ...data,
            noteText: modifiedNoteText,
            loggerExchangeReason: data.statusChange?.loggerExchangeReason,
            requiredLoggerExchange: data.statusChange?.requiredLoggerExchange,
        }
    }, [data])

    const {
        gridWrapper, gridAreaTemplate, ...restClasses
    } = getClassNames(data.noteType, classes)

    const fields = useMemo(() => {
        return injectClass(getFields({
            noteType: data.noteType,
            isNewStatusLoggerToBeExchanged:
                data.statusChange?.statusCodeNew === ContainerStatus.TO_BE_LOGGER_EXCHANGED,
            getAllowedValues,
        }), classes)
    }, [
        classes,
        data,
        getAllowedValues,
    ])

    return (
        <div className={classes.rowFormContainer}>
            <DomainObjectForm
                name={name}
                className={clsx(
                    gridWrapper, gridAreaTemplate,
                )}
                classNames={restClasses}
                value={modifiedNote}
                fields={fields}
                exists
                disabled
            />
        </div>
    )
}

export default ContainerNoteDetails
